(function() {
  var GIFT_HANDLE = 'sb-tools-gift-card';
  var RANGE = '$25.00 – $250.00';
  function rewrite() {
    var cards = document.querySelectorAll('.card-wrapper');
    cards.forEach(function(card) {
      var link = card.querySelector('a[href*="' + GIFT_HANDLE + '"]');
      if (!link) return;
      if (card.dataset.giftRange === '1') return;
      var priceItems = card.querySelectorAll('.price-item--regular, .price-item--sale, .price-item--last');
      if (!priceItems.length) return;
      priceItems.forEach(function(el) {
        el.textContent = RANGE;
      });
      card.dataset.giftRange = '1';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewrite);
  } else { rewrite(); }
  // Re-run for infinite scroll / AJAX-loaded cards
  new MutationObserver(rewrite).observe(document.body, {childList: true, subtree: true});
})();
// sb-tools: free wrench with handle (v2 — robust + 1-per-order)
(function() {
  var HANDLE_PAGES = ['48in-handle','48-handle-new-style','set-of-3-handles-with-connector','taper-lock-handle-sets','set-of-4-handles-with-connector','4-handles-with-connector'];
  var WRENCH_VARIANT_ID = 48603116994784;
  var LOG_PREFIX = '[sb-wrench]';

  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function isHandlePage() { return HANDLE_PAGES.indexOf(currentHandle()) !== -1; }

  function makeBox() {
    var box = document.createElement('div');
    box.className = 'wrench-gift-option';
    box.setAttribute('data-sb-wrench','1');
    box.style.cssText = 'padding:14px 16px !important;background:#fffbe6 !important;border:2px solid #ffe300 !important;border-radius:8px !important;margin:16px 0 !important;display:block !important;';
    box.innerHTML = '<label for="add-free-wrench" style="display:flex !important;align-items:center;gap:12px;cursor:pointer;font-size:1.05em;margin:0;color:#222;">' +
      '<input type="checkbox" id="add-free-wrench" style="width:22px;height:22px;cursor:pointer;flex-shrink:0;">' +
      '<span>&#127873; <strong>Add a FREE Bench Wrench</strong> <span style="color:#666;text-decoration:line-through;font-size:0.9em">$9.95</span> with my order</span></label>';
    return box;
  }

  function inject() {
    if (!isHandlePage()) return false;
    if (document.getElementById('add-free-wrench')) return true;
    // Prefer product-form, then any /cart/add form, then submit-button parent
    var host = document.querySelector('product-form form') 
            || document.querySelector('form[action$="/cart/add"], form[action*="/cart/add"]')
            || document.querySelector('.product-form__buttons');
    if (!host) return false;
    var anchor = host.querySelector('.product-form__buttons') 
              || host.querySelector('button[type="submit"], .product-form__submit');
    var box = makeBox();
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(box, anchor);
    } else {
      host.appendChild(box);
    }
    console.log(LOG_PREFIX, 'injected checkbox on', currentHandle());
    return true;
  }

  function tryInject() {
    if (!isHandlePage()) return;
    if (inject()) return;
    // retry a few times as Dawn hydrates
    var tries = 0;
    var iv = setInterval(function() {
      if (inject() || ++tries > 20) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInject);
  } else { tryInject(); }
  window.addEventListener('load', tryInject);
  new MutationObserver(function() { if (isHandlePage() && !document.getElementById('add-free-wrench')) inject(); }).observe(document.documentElement, {childList:true, subtree:true});

  // Intercept form submit
  document.addEventListener('submit', function(e) {
    if (!isHandlePage()) return;
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var cb = document.getElementById('add-free-wrench');
    if (!cb || !cb.checked) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var fd = new FormData(form);
    var handleVariantId = parseInt(fd.get('id'), 10);
    var handleQty = parseInt(fd.get('quantity') || '1', 10) || 1;
    var props = {};
    fd.forEach(function(v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m) props[m[1]] = v;
    });
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) { submitBtn.setAttribute('aria-disabled','true'); submitBtn.classList.add('loading'); }
    // First check if wrench already in cart
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var wrenchInCart = (cart.items || []).some(function(i){ return i.variant_id === WRENCH_VARIANT_ID; });
        var items = [{ id: handleVariantId, quantity: handleQty }];
        if (Object.keys(props).length) items[0].properties = props;
        if (!wrenchInCart) items.push({ id: WRENCH_VARIANT_ID, quantity: 1 });
        return fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items: items })
        });
      })
      .then(function(r){ return r.json(); })
      .then(function(){ window.location.href = '/cart'; })
      .catch(function(err){
        console.error(LOG_PREFIX, err);
        alert('Could not add items to cart. Please try again.');
        if (submitBtn) { submitBtn.removeAttribute('aria-disabled'); submitBtn.classList.remove('loading'); }
      });
  }, true);
})();
// sb-tools: bolster engraving option on NRS pages (v2 — button + 3 lines + $15 fee)
(function() {
  var NRS_HANDLES = ['nrs-1-swept-back-left','nrs-15-45-degree-double-edge','nrs-15-65-degree-skewed-left','nrs-1-5-65-skewed-right-body-and-blade-options','nrs-15-straight-domed-blades','nrs-15-swept-back-left','nrs-1-5-swept-back-left-or-right-body-and-blade-options-copy','nrs-2-65-degree-skewed-right','nrs-2-65-skewed-right-body-and-blade-options','nrs-25-45-degree-double-edge','nrs-25-45-degree-skewed-left','nrs-25-outer-bowl','nrs-2-5-outer-bowl-right-body-and-blade-options','nrs-25-swept-inner-bowl','nrs-275-large-round-inner-bowl','nrs-1-dot-5-straight-and-domed-body-and-blade-options','nrs-5-dot-25-large-radius-inner-bowl-body-and-blade-options','nrs-525-large-round-inner-bowl'];
  var MAX_CHARS = 10;
  var ENGRAVING_VARIANT_ID = 53503160615136;
  var ENGRAVING_FEE_LABEL = '$15';

  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function isNrsPage() { return NRS_HANDLES.indexOf(currentHandle()) !== -1; }

  function build() {
    var wrap = document.createElement('div');
    wrap.className = 'sb-engraving-wrap';
    wrap.setAttribute('data-sb-engraving','1');
    wrap.style.cssText = 'margin:16px 0 !important;';
    wrap.innerHTML =
      '<button type="button" id="sb-engraving-toggle" style="width:100%;padding:12px 16px;background:#fffbe6;border:2px solid #ffe300;border-radius:8px;font-size:1.05em;font-weight:600;cursor:pointer;color:#222;text-align:center;">' +
      '&#128393; Add custom text (+' + ENGRAVING_FEE_LABEL + ')' +
      '</button>' +
      '<div id="sb-engraving-panel" style="display:none;padding:16px;background:#fffbe6;border:2px solid #ffe300;border-top:none;border-radius:0 0 8px 8px;margin-top:-2px;">' +
      '<p style="margin:0 0 12px;color:#222;font-size:0.95em;">Engraved on the bolster, the opposite side to the SB Tools logo.</p>' +
      '<img src="https://cdn.shopify.com/s/files/1/0763/2918/9600/files/engraving-example.jpg?v=1784676376" alt="Engraving example" style="width:100%;max-width:280px;border-radius:6px;margin:0 auto 12px;display:block;" loading="lazy">' +
      '<p style="margin:0 0 12px;padding:8px 10px;background:#fff3cd;border-left:4px solid #ffe300;color:#664d03;font-size:0.9em;"><strong>Please note:</strong> the text will be engraved exactly as written \u2014 including capitalization, punctuation, and spelling.</p>' +
      lineHtml(1) + lineHtml(2) + lineHtml(3) +
      '<p style="margin:10px 0 0;font-size:0.9em;color:#666;">Adding text will add a <strong>' + ENGRAVING_FEE_LABEL + ' engraving fee</strong> to your order.</p>' +
      '<button type="button" id="sb-engraving-remove" style="margin-top:10px;padding:6px 12px;background:transparent;border:1px solid #999;border-radius:6px;font-size:0.85em;cursor:pointer;color:#555;">Remove engraving</button>' +
      '</div>';
    return wrap;
  }
  function lineHtml(n) {
    return '<label style="display:block;margin:8px 0 4px;font-weight:600;color:#222;font-size:0.9em;">Line ' + n + '</label>' +
      '<input type="text" class="sb-engraving-line" data-line="' + n + '" maxlength="' + MAX_CHARS + '" placeholder="Up to ' + MAX_CHARS + ' characters" style="width:100%;padding:8px 10px;border:1px solid #ccc;border-radius:6px;font-size:1em;box-sizing:border-box;">';
  }

  function inject() {
    if (!isNrsPage()) return false;
    if (document.querySelector('[data-sb-engraving]')) return true;
    var host = document.querySelector('product-form form')
            || document.querySelector('form[action$="/cart/add"], form[action*="/cart/add"]');
    if (!host) return false;
    var anchor = host.querySelector('.product-form__buttons')
              || host.querySelector('button[type="submit"], .product-form__submit');
    var wrap = build();
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor);
    else host.appendChild(wrap);
    var btn = document.getElementById('sb-engraving-toggle');
    var panel = document.getElementById('sb-engraving-panel');
    var remove = document.getElementById('sb-engraving-remove');
    btn.addEventListener('click', function() {
      panel.style.display = 'block';
      btn.style.borderRadius = '8px 8px 0 0';
      btn.textContent = '✓ Engraving added — edit below';
    });
    remove.addEventListener('click', function() {
      panel.style.display = 'none';
      btn.style.borderRadius = '8px';
      btn.innerHTML = '&#128393; Add custom text (+' + ENGRAVING_FEE_LABEL + ')';
      wrap.querySelectorAll('.sb-engraving-line').forEach(function(i){ i.value=''; });
    });
    console.log('[sb-engraving] injected on', currentHandle());
    return true;
  }
  function tryInject() {
    if (!isNrsPage()) return;
    if (inject()) return;
    var tries = 0;
    var iv = setInterval(function(){ if (inject() || ++tries > 20) clearInterval(iv); }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tryInject);
  else tryInject();
  window.addEventListener('load', tryInject);
  new MutationObserver(function(){ if (isNrsPage() && !document.querySelector('[data-sb-engraving]')) inject(); }).observe(document.documentElement, {childList:true, subtree:true});

  // Intercept form submit — attach line-item properties and add fee product
  document.addEventListener('submit', function(e) {
    if (!isNrsPage()) return;
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var panel = document.getElementById('sb-engraving-panel');
    if (!panel || panel.style.display === 'none') return; // not engraving
    var lines = [];
    wrap: for (var i=1; i<=3; i++) {
      var el = form.querySelector('.sb-engraving-line[data-line="'+i+'"]') || document.querySelector('.sb-engraving-line[data-line="'+i+'"]');
      lines.push(el ? el.value.trim() : '');
    }
    if (!lines.some(function(l){return l.length>0;})) return; // all empty
    e.preventDefault();
    e.stopImmediatePropagation();
    var fd = new FormData(form);
    var handleVariantId = parseInt(fd.get('id'), 10);
    var handleQty = parseInt(fd.get('quantity') || '1', 10) || 1;
    var props = {};
    fd.forEach(function(v,k){ var m=k.match(/^properties\[(.+)\]$/); if(m) props[m[1]]=v; });
    if (lines[0]) props['Engraving Line 1'] = lines[0];
    if (lines[1]) props['Engraving Line 2'] = lines[1];
    if (lines[2]) props['Engraving Line 3'] = lines[2];

    var titleEl = document.querySelector('.product__title, h1.product__title, h1');
    var itemName = titleEl ? titleEl.textContent.trim() : '';
    var items = [
      { id: handleVariantId, quantity: handleQty, properties: props },
      { id: ENGRAVING_VARIANT_ID, quantity: 1, properties: {
          'For Product': itemName || ('variant ' + handleVariantId),
          'Engraving Line 1': lines[0] || '',
          'Engraving Line 2': lines[1] || '',
          'Engraving Line 3': lines[2] || '',
      }}
    ];
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) { submitBtn.setAttribute('aria-disabled','true'); submitBtn.classList.add('loading'); }
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items: items })
    }).then(function(r){ if(!r.ok){ return r.json().then(function(err){ throw new Error(err.description || err.message || 'Add to cart failed'); }); } return r.json(); }).then(function(){
      window.location.href = '/cart';
    }).catch(function(err){
      console.error('[sb-engraving]', err);
      alert('Could not add engraving to cart. Please try again.');
      if (submitBtn) { submitBtn.removeAttribute('aria-disabled'); submitBtn.classList.remove('loading'); }
    });
  }, true);
})();
// sb-tools: engraving body-gate v2 — safe (no MO), poll variant id
(function() {
  var NRS_HANDLES = ['nrs-1-swept-back-left','nrs-15-45-degree-double-edge','nrs-15-65-degree-skewed-left','nrs-1-5-65-skewed-right-body-and-blade-options','nrs-15-straight-domed-blades','nrs-15-swept-back-left','nrs-1-5-swept-back-left-or-right-body-and-blade-options-copy','nrs-2-65-degree-skewed-right','nrs-2-65-skewed-right-body-and-blade-options','nrs-25-45-degree-double-edge','nrs-25-45-degree-skewed-left','nrs-25-outer-bowl','nrs-2-5-outer-bowl-right-body-and-blade-options','nrs-25-swept-inner-bowl','nrs-275-large-round-inner-bowl','nrs-1-dot-5-straight-and-domed-body-and-blade-options','nrs-5-dot-25-large-radius-inner-bowl-body-and-blade-options','nrs-525-large-round-inner-bowl'];
  function currentHandle() { var m = location.pathname.match(/\/products\/([^/?#]+)/); return m ? m[1] : null; }
  if (NRS_HANDLES.indexOf(currentHandle()) === -1) return;

  var bladeOnlyIds = null;
  var lastVid = null;

  function currentVariantId() {
    // Prefer product-form's active hidden input
    var inputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      if (!inputs[i].disabled && inputs[i].value) return parseInt(inputs[i].value, 10);
    }
    // Fallback: URL ?variant=
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? parseInt(m[1], 10) : null;
  }

  function apply() {
    var wrap = document.querySelector('[data-sb-engraving]');
    if (!wrap || bladeOnlyIds === null) return;
    var vid = currentVariantId();
    if (vid === lastVid) return; // no change
    lastVid = vid;
    var isBladeOnly = vid && bladeOnlyIds.indexOf(vid) !== -1;
    if (isBladeOnly) {
      wrap.style.display = 'none';
      var panel = document.getElementById('sb-engraving-panel');
      var btn = document.getElementById('sb-engraving-toggle');
      if (panel) panel.style.display = 'none';
      if (btn) { btn.style.borderRadius = '8px'; btn.innerHTML = '&#128393; Add custom text (+$15)'; }
      wrap.querySelectorAll('.sb-engraving-line').forEach(function(i){ i.value = ''; });
    } else {
      wrap.style.display = 'block';
    }
  }

  fetch('/products/' + currentHandle() + '.js', {headers:{'Accept':'application/json'}})
    .then(function(r){ return r.json(); })
    .then(function(product) {
      bladeOnlyIds = (product.variants || []).filter(function(v){ return /blade\s*only/i.test(v.title || ''); }).map(function(v){ return v.id; });
      console.log('[sb-engraving] blade-only variant ids:', bladeOnlyIds);
      lastVid = null; // force first apply
      apply();
    }).catch(function(e){ console.error('[sb-engraving] product fetch failed', e); });

  // Poll every 400ms — cheap, no observer feedback loops
  setInterval(apply, 400);
})();
